import type { ModelReleaseEvidenceEntry } from "@/components/ModelReleaseEvidenceVisuals";

export const MODEL_RELEASE_NEWS_SLUG = "openai-anthropic-new-model-clues-business-evaluation";
export const MODEL_RELEASE_EVIDENCE: ModelReleaseEvidenceEntry[] = [
  {
    "date": "2026-09-01",
    "label": "Official Mythos page dates its Mythos 5.1 announcement September 1; this is not a 5.5 announcement.",
    "status": "Confirmed",
    "url": "https://www.anthropic.com/claude/mythos"
  },
  {
    "date": "2026-09-03",
    "label": "OpenAI API changelog records GPT-6 Astra release; not GPT-6.2 Astra.",
    "status": "Confirmed",
    "url": "https://developers.openai.com/api/docs/changelog"
  },
  {
    "date": "2026-10-17",
    "label": "TestingCatalog publishes separate Fable 5.5 partner-access rumor report; report date, not release date.",
    "status": "Reported",
    "url": "https://www.testingcatalog.com/anthropic-several-models-coming-fable-5-5-reaches-partners/"
  },
  {
    "date": "2026-11-01",
    "label": "TestingCatalog publishes Mythos 5.5 website-reference report; report date, not release date.",
    "status": "Reported",
    "url": "https://www.testingcatalog.com/anthropic-prepares-to-release-claude-mythos-5-5-model/"
  },
  {
    "date": "2026-11-02",
    "label": "TestingCatalog publishes GPT-6.2 Astra usage-identifier report; report date, not release date.",
    "status": "Reported",
    "url": "https://www.testingcatalog.com/gpt-6-2-astra-appears-codex-usage/"
  },
  {
    "date": "2026-11-03",
    "label": "Editorial source check: reviewed official sources do not announce these reported names; current Mythos response still identifies 5.1.",
    "status": "Confirmed",
    "url": "https://www.anthropic.com/claude/mythos"
  }
];
